import { useCallback, useState } from "react"

const useHover = () => {
  const [isHovered, setIsHovered] = useState(false)

  const onPointerEnter = useCallback(() => {
    if (!isHovered) {
      setIsHovered(true)
    }
  }, [isHovered])

  const onPointerLeave = useCallback(() => {
    if (isHovered) {
      setIsHovered(false)
    }
  }, [isHovered])

  return {
    isHovered,
    hoverProps: {
      onPointerEnter,
      onPointerLeave,
    },
  }
}

export default useHover
